var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWordmarkReverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 540.75 82.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#48bea6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.23,34.4c4.53-3.18,6.23-7,6.23-11.65,0-9.33-6.93-16.87-18.66-16.87H150.2V65.1H179c11.82,0,18.76-7.5,18.76-16.74A14.42,14.42,0,0,0,188.23,34.4ZM159.35,14.08H175c5.45,0,10.12,2.79,10.12,8.67,0,5.11-3.58,8.68-9.64,8.68h-16.1Zm19.54,42.83H159.35V39h19.5c5.67,0,9.42,3.75,9.42,9.34C188.27,53.5,184.43,56.91,178.89,56.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.1,3.87a5.08,5.08,0,0,0-5.32,5.32,5.35,5.35,0,0,0,10.69,0A5.12,5.12,0,0,0,245.1,3.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 240.78,
    y: 23.23,
    width: 8.64,
    height: 41.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281,22.36c-12.51,0-21.54,9.34-21.54,21.81,0,12.91,9.72,21.81,23.81,21.81a31.69,31.69,0,0,0,16-4.1L297.88,54c-5.59,2.66-9.77,3.92-14.66,3.92-8.11,0-13.43-3.79-15-10.64h32.58C303.33,33.7,294.56,22.36,281,22.36ZM268.52,40.42c.66-6.06,5.8-10.16,12.69-10.16s11.26,4.1,11.82,10.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.13,18.7V30.56L311,65.1h8.64V30.56h12.21V23.23H319.51V19.18c0-6.06,2.62-8.77,8.24-8.77a15.57,15.57,0,0,1,5.63,1.09l.91-7.15a15.21,15.21,0,0,0-6.93-1.53C317.15,2.82,311.13,9,311.13,18.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.94,22.36C356.83,22.36,352.12,27,349,31V20.34L340.39,23V82.55H349V59.39c3.09,4,7.8,6.59,14.91,6.59,11.91,0,21-8.73,21-21.59S375.85,22.36,363.94,22.36Zm-1,35.85a13.53,13.53,0,0,1-13.83-13.82c0-7.72,5.76-14.26,13.83-14.26s13.43,6.54,13.43,14.26S371,58.21,362.9,58.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M414.36,22.36c-12.73,0-22.24,9.55-22.24,21.81S401.63,66,414.36,66s22.25-9.55,22.25-21.81S427.1,22.36,414.36,22.36Zm0,35.5a13.32,13.32,0,0,1-13.61-13.69,13.61,13.61,0,1,1,27.22,0A13.32,13.32,0,0,1,414.36,57.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 446.55,
    y: 23.23,
    width: 8.64,
    height: 41.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M450.87,3.87a5.08,5.08,0,0,0-5.32,5.32,5.34,5.34,0,0,0,10.68,0A5.11,5.11,0,0,0,450.87,3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M489.55,22.36c-7.5,0-11.47,6.18-12.86,8.32V20.34L468,23V65.1h8.63V41.51c0-6.94,5.19-10.95,11.56-10.95s10.3,4,10.3,11V65.1h8.63V39.68C507.13,29.52,501.07,22.36,489.55,22.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M532.29,56.13a6.77,6.77,0,0,1-6.77-6.76V30.57h12.86V23.25H525.52v-.83h0V9.8l-8.85,2.66V22.57c0,1.5,0,15.16,0,27.4A15.08,15.08,0,0,0,531.74,65h9v-8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.67,22.36c-7.51,0-11.46,6.19-12.86,8.31V20.34L208.12,23v42.1h8.64V41.51c0-6.94,5.18-11,11.56-11a12.53,12.53,0,0,1,3.09.36l2.81-8.11A22.3,22.3,0,0,0,229.67,22.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.8 60.5 96.59 36.39 104.63 24.11 85.42 0 0 0 19.21 24.11 97.25 24.11 89.16 36.39 38.46 36.39 57.67 60.5 108.42 60.5 100.32 72.78 107.76 72.78 115.8 60.5 115.79 60.5 115.8 60.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWordmarkReverse);
export default __webpack_public_path__ + "static/media/logo-wordmark-reverse.3c5b30da6502efa5e9f47f4a94e78053.svg";
export { ForwardRef as ReactComponent };